import Layout from "../../layout/main";
import WalletBalanceReports from "../../components/walletBalanceReports";

const WalletBalanceReportsPage = () => {
  return (
    <Layout>
      <WalletBalanceReports />
    </Layout>
  );
};

export default WalletBalanceReportsPage;
